import { useCallback, useEffect, useMemo, useState } from "react";
import DistrictSidebar from "../../components/DistrictSidebar";
import ESMPTable from "../../components/ESMPTable";
import api from "../../services/api";

export default function PendingReviews() {
  const [search, setSearch] = useState("");
  const [esmps, setEsmps] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMyEsmps = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/district/my-esmps");
      const data = Array.isArray(res.data?.data) ? res.data.data : [];
      const normalized = data.map((item) => ({
        ...item,
        projectName: item.project_name || item.projectName || "",
        submittedBy: item.User?.name || item.submittedBy || "N/A",
      }));
      setEsmps(normalized);
    } catch (err) {
      console.error("Failed to load pending ESMPs:", err);
      setEsmps([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMyEsmps();
  }, [fetchMyEsmps]);

  const filtered = useMemo(
    () =>
      esmps
        .filter((e) => ["Submitted", "Pending"].includes(e.status))
        .filter(
          (e) =>
            (e.projectName || "").toLowerCase().includes(search.toLowerCase()) ||
            (e.district || "").toLowerCase().includes(search.toLowerCase()) ||
            (e.submittedBy || "").toLowerCase().includes(search.toLowerCase())
        ),
    [esmps, search]
  );

  return (
    <div className="flex h-screen overflow-hidden bg-gray-100">
      <DistrictSidebar />
      <main className="flex-1 overflow-y-auto p-6 space-y-6">
        <div className="flex justify-between items-center bg-gradient-to-r from-green-700 to-green-500 text-white p-5 rounded-xl shadow-md">
          <h2 className="text-2xl font-bold">Pending Reviews</h2>
          <input
            type="text"
            placeholder="Search ESMP..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-3 py-2 rounded text-black border focus:ring-2 focus:ring-green-600 outline-none"
          />
        </div>

        <div className="bg-white p-6 rounded-xl shadow">
          {loading ? (
            <p className="text-gray-500">Loading pending ESMPs...</p>
          ) : (
            <ESMPTable
              data={filtered}
              emptyMessage="No pending ESMPs."
              showReceiptButton={false}
            />
          )}
        </div>
      </main>
    </div>
  );
}
